module.exports = __webpack_public_path__ + "img/00222.5bf7204d.png";